import { isEmpty, isEqual, isNil } from "lodash";

export const removeEmptyValues = formData => {
  const data = Object.fromEntries(formData);

  for (const key in data) {
    if (
      isEmpty(data[key]) ||
      isNil(data[key]) ||
      isEqual(data[key], "null") ||
      isEqual(data[key], "undefined")
    ) {
      delete data[key];
      formData.delete(key);
    }
  }
};
